import store from "../store/store.js";

export const CONTENTFUL = {
  spaceId: "basq0669kq3q",
  accessToken: "WCcW996ZOGCnQ6MfEvSSW4g9DnT0KekSBTjbvWfSrrA",
};
export const CONTENTFUL_URL_API = `https://cdn.contentful.com/spaces/${CONTENTFUL.spaceId}/entries?access_token=${CONTENTFUL.accessToken}`;

export const contentfulMixin = {
  data() {
    return {
      prices: null,
    };
  },
  methods: {
    async getPrices() {
      this.getStoreData();

      if (!this.prices) {
        await this.loadContent();
      }
      return this.prices;
    },
    async loadContent() {
      try {
        const response = await fetch(`${CONTENTFUL_URL_API}`);
        const data = await response.json();

        this.prices = data.items?.[0]?.fields;

        store.setData({
          prices: this.prices,
        });
      } catch (error) {
        console.error("Error fetching Contentful content:", error);
      }
    },
    getStoreData() {
      this.prices = store.getData()?.prices;
    },
  },
};
